export default "__VITE_ASSET__17a1f529__"